<template>
  <div class="social-complete-modal">
    <h2>Eksik Bilgileri Tamamla</h2>
    <p>Google hesabınızla giriş yaptınız. Devam edebilmek için aşağıdaki bilgileri doldurmanız gerekiyor.</p>

    <!-- Telefon -->
    <div class="form-group">
      <label>Telefon Numarası</label>
      <div class="phone-input">
        <select v-model="selectedCountryCode">
          <option v-for="c in countryCodes" :key="c.dial_code" :value="c.dial_code">
            {{ c.dial_code }} ({{ c.code }})
          </option>
        </select>
        <input
          type="tel"
          v-model="phone"
          placeholder="Telefon numarası"
        />
      </div>
    </div>

    <!-- Para Birimi -->
    <div class="form-group">
      <label>Para Birimi</label>
      <select v-model="fiatCurrency">
        <option v-for="c in fiatCurrencies" :key="c.code" :value="c.code">
          {{ c.label }}
        </option>
      </select>
    </div>

    <!-- Buton -->
    <div class="actions">
      <button @click="submitInfo" :disabled="loading">
        <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Kaydediliyor...</span>
        <span v-else>Tamamla</span>
      </button>
    </div>
  </div>
</template>

<script>
import countryCodes from "@/assets/data/countryCodes.json";

export default {
  name: "SocialComplete",
  props: ["userId"], 
  data() {
    return {
      phone: "",
      selectedCountryCode: "+90",
      fiatCurrency: "TRY",
      loading: false,
      countryCodes,
      fiatCurrencies: [
        { code: "USD", label: "USD - US Dollar" },
        { code: "EUR", label: "EUR - Euro" },
        { code: "TRY", label: "TRY - Turkish Lira" },
        { code: "GBP", label: "GBP - British Pound" },
        { code: "CAD", label: "CAD - Canadian Dollar" },
        { code: "AUD", label: "AUD - Australian Dollar" }
      ]
    };
  },
  methods: {
    async submitInfo() {
      if (!this.phone) {
        this.$emit("notify", { type: "error", message: "Telefon numarası gerekli" });
        return;
      }

      this.loading = true;
      try {
        const fullPhone = `${this.selectedCountryCode}${this.phone}`;
        const res = await this.$axios.post("/auth/social/complete", {
          userId: this.userId,
          phone: fullPhone,
          fiatCurrency: this.fiatCurrency
        });

        if (res.data.success) {
          // ✅ Token kaydet
          localStorage.setItem("token", res.data.token);
          this.$axios.defaults.headers.common["x-auth-token"] = res.data.token;

          // ✅ Vuex'e user + token yaz
          this.$store.commit("auth_set_token", res.data.token);
          this.$store.commit("auth_set_user", res.data.user);

          this.$store.dispatch("socketConnectGeneral");
          this.$store.dispatch("socketConnectCashier");
          if (res.data.user.rank === "admin" || res.data.user.rank === "mod") {
            this.$store.dispatch("socketConnectAdmin");
          }

          this.$emit("notify", { type: "success", message: "Giriş tamamlandı" });
          this.$store.dispatch("modalsSetShow", null); // modal kapat
        } else {
          this.$emit("notify", { type: "error", message: res.data.message || "Bir hata oluştu" });
        }
      } catch (err) {
        console.error("SocialComplete error:", err);
        this.$emit("notify", { type: "error", message: "Sunucu hatası" });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>


<style scoped>
.social-complete-modal {
  padding: 20px;
  background: #1e1e2f;
  border-radius: 12px;
  color: white;
  max-width: 400px;
}

.form-group {
  margin-bottom: 15px;
}

.phone-input {
  display: flex;
}

.phone-input select {
  margin-right: 8px;
}
</style>
